import Authorization from '../../../../../stores/Authorization';
import Common from '../../../../../stores/Common';
import { EasyUpdateButton } from '../../../EasyUpdateButton';
import { IReportDepositionModel } from '../../../../../interfaces/Report/ITimelineReport';
import { IUserModel } from '../../../../../interfaces/IUser';
import { Link } from 'react-router-dom';
import { LocalRoutes } from '../../../../../utilities/LocalRoutes';
import { useZoneContext } from '../../../../../contexts/useZoneContext';

export interface IDepositionsTableProps {
    depositions: IReportDepositionModel[];
    easyUpdateAttemptedGuids: string[];
    reportCaseDetailsLastColumnDisplayName?: string;
    isReadOnly: boolean;
    onEasyUpdateClick: (caseGuid: string) => void;
    user: IUserModel;
}

export function DepositionsTable(props: IDepositionsTableProps) {
    const zoneContext = useZoneContext();
    
    return (
        <>
            {props.depositions.length > 0 && (
                <table className="table margin-left-20" style={{ width: '98.5%' }}>
                    <thead>
                        <tr>
                            <th>Case Name</th>
                            <th>Jurisdiction</th>
                            <th>Plaintiffs Firm</th>
                            <th>Witness</th>
                            <th>Status</th>
                            <th>Date</th>
                            <th>
                                {props.reportCaseDetailsLastColumnDisplayName ??
                                    'Last Column Header Name'}
                            </th>
                            {Authorization.isAuthorizedToRoute(
                                LocalRoutes.CaseEasyUpdate,
                                props.user,
                                zoneContext.zoneGuid
                            ) && <th></th>}
                        </tr>
                    </thead>
                    <tbody>
                        {props.depositions.map((item: IReportDepositionModel, idx) => {
                            const easyUpdateAttempted =
                                props.easyUpdateAttemptedGuids.filter((x) => x === item.caseGuid)
                                    .length > 0;

                            return (
                                <tr key={idx}>
                                    <td className="col-sm-2">
                                        <Link
                                            target="_blank"
                                            to={zoneContext.buildZoneUrl(LocalRoutes.CaseFile.replace(
                                                ':guid',
                                                item.caseGuid
                                            ))}
                                        >
                                            {item.caseName}
                                        </Link>
                                    </td>
                                    <td className="col-sm-2">{item.jurisdiction}</td>
                                    <td className="col-sm-2">{item.plaintiffsFirm}</td>
                                    <td className="col-sm-2">{item.witness}</td>
                                    <td className="col-sm-2">{item.status.displayName}</td>
                                    <td className="col-sm-1">{Common.dateFormat(item.date)}</td>
                                    <td className="col-sm-1">{item.additionalCaseIdentifier}</td>
                                    {Authorization.isAuthorizedToRoute(
                                        LocalRoutes.CaseEasyUpdate,
                                        props.user,
                                        zoneContext.zoneGuid
                                    ) && (
                                        <td className="center" style={{ width: '3%' }}>
                                            {!props.isReadOnly && (
                                                <EasyUpdateButton
                                                    caseGuid={item.caseGuid}
                                                    onClick={() => {
                                                        props.onEasyUpdateClick(item.caseGuid);
                                                    }}
                                                    visited={easyUpdateAttempted}
                                                />
                                            )}
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
        </>
    );
}
